import React from "react";
import { Box } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";

const socials = [
  {
    icon: InstagramIcon,
    bg: "linear-gradient(45deg, #f58529, #dd2a7b, #8134af)",
    link: "https://www.instagram.com/mountainbhraman?igsh=MTg3czA2dnV5eTZqcw==",
  },
  {
    icon: FacebookIcon,
    bg: "linear-gradient(45deg, #1877F2, #42A5F5)",
    link: "https://facebook.com",
  },
  {
    icon: YouTubeIcon,
    bg: "linear-gradient(45deg, #FF0000, #FF5252)",
    link: "https://www.youtube.com/@himachaltourswithajay",
  },
];

const SocialMediaComp = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        right: "18px",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        zIndex: 9999,
      }}
    >
      {socials.map(({ icon: Icon, bg, link }, i) => (
        <Box
          key={i}
          onClick={() => window.open(link, "_blank")}
          sx={{
            width: 42,
            height: 42,
            borderRadius: "0%",
            background: bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 6px 15px rgba(0,0,0,0.35)",
            transition: "0.3s ease",
            "&:hover": {
              transform: "scale(1.15)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
            },
          }}
        >
          <Icon sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
      ))}
    </Box>
  );
};

export default SocialMediaComp;
